import {useEffect, useRef, useState} from 'react'

export function useIsStreamingComplete(isStreaming: boolean | undefined): boolean {
  const [hasStreamingCompleted, setHasStreamingCompleted] = useState(false)
  const hasStreamingStartedRef = useRef(isStreaming)

  useEffect(() => {
    // Track if streaming ever started
    if (isStreaming) {
      hasStreamingStartedRef.current = true
    }

    // Only mark as completed if streaming was previously true and is now false
    if (!isStreaming && hasStreamingStartedRef.current && !hasStreamingCompleted) {
      setHasStreamingCompleted(true)
    }
  }, [isStreaming, hasStreamingCompleted])

  return hasStreamingCompleted
}
